/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TheCargo Billing
 * Handles all customer-facing money movement for TheCargo: deposits, balance payments, refunds, and reconciliation against external processors.

## Payment Lifecycle

Each payment row tracks one charge through these states:

| Status | Meaning |
|--------|---------|
| `pending` | Authorization sent to the processor, awaiting capture |
| `paid` | Funds captured and settled |
| `failed` | Processor rejected the charge — see `error` field |
| `refunded` | Funds returned to the customer |
| `canceled` | Authorization voided before capture |

## Authentication

Most endpoints require a JWT Bearer token issued by the **Auth Service**:
```
Authorization: Bearer <access_token>
```

The Stripe webhook receiver is intentionally **unauthenticated** — Stripe signs each request with the webhook secret, which the service verifies before acting.

## Multi-tenancy

Every payment row is scoped to the caller's organization. Service-to-service calls (e.g. shipment posting a balance payment) use `X-Service-Secret` instead of a JWT and target `/api/internal/*`.

## Contact

For API access or issues contact **support@thecargo.io**
 * OpenAPI spec version: 1.0.0
 */

export type TransactionStatus =
  (typeof TransactionStatus)[keyof typeof TransactionStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TransactionStatus = {
  pending: 'pending',
  succeeded: 'succeeded',
  failed: 'failed',
} as const
